import { styled } from '@mui/system';
import { createStaticMapsUrl, StaticMap } from '@vis.gl/react-google-maps';

import { GeoCoordinate } from '~interfaces';
import { Dimens } from '~themes';

interface GoogleMapProps {
	geoCoordinate: GeoCoordinate;
	zoom?: number;
	height?: number;
	width?: number;
	clickToOpenGoogleMaps?: boolean;
}

const StaticGoogleMap = ({
	geoCoordinate,
	zoom = 12,
	height = 320,
	width = 600,
	clickToOpenGoogleMaps = true,
}: GoogleMapProps) => {
	const url = createStaticMapsUrl({
		apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
		width: width,
		height: height,
		center: { lat: geoCoordinate.latitude, lng: geoCoordinate.longitude },
		markers: [
			{
				location: { lat: geoCoordinate.latitude, lng: geoCoordinate.longitude },
			},
		],
		zoom: zoom,
	});

	return clickToOpenGoogleMaps ?
			<a
				href={`https://www.google.com/maps/search/?api=1&query=${geoCoordinate.latitude},${geoCoordinate.longitude}`}
				target='_blank'
			>
				<StyledStaticMap sx={{ objectFit: 'cover' }} url={url} />
			</a>
		:	<StyledStaticMap url={url} />;
};

const StyledStaticMap = styled(StaticMap)(() => ({
	borderRadius: Dimens.radiusMd,
}));

export default StaticGoogleMap;
